import { render } from "./topAnchor.vue?vue&type=template&id=0da1d622&scoped=true"
import script from "./topAnchor.vue?vue&type=script&lang=js"
export * from "./topAnchor.vue?vue&type=script&lang=js"

import "./topAnchor.vue?vue&type=style&index=0&id=0da1d622&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0da1d622"]])

export default __exports__